import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyFileWithSignedUrlResponse, HttpResponse } from "@/types";

export function useGetCompanyFile({
  companyFileId,
  enabled,
}: {
  companyFileId: number;
  enabled: boolean;
}) {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    enabled,
    queryKey: ["files", currentCompanyId, companyFileId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/files/${companyFileId.toString()}`;
      const res = await guacHttpClient.get<
        CompanyFileWithSignedUrlResponse,
        HttpResponse<CompanyFileWithSignedUrlResponse>
      >(path);
      return res.data;
    },
  });
}
